import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import Datetime from 'utils/datetime/datetime'

import { useLatestScenarioOptimizationPeriod } from './hooks/useLatestScenarioOptimizationPeriod'

type ScenarioOptimizationPeriodInfoProps = {
  subtypes: string[] | null
}

export function ScenarioOptimizationPeriodInfo({ subtypes }: ScenarioOptimizationPeriodInfoProps): ReactNode {
  const { t } = useTranslation()
  const latestOptimizationPeriod = useLatestScenarioOptimizationPeriod(subtypes)

  return (
    <div className="pt-1.25 mr-2.5 text-grey-6 text-xs">
      {latestOptimizationPeriod
        ? t('Last optimized: {{duration}} ago for period {{start}} - {{end}}', {
            duration: Datetime.getDurationInHoursAndMinutes(
              latestOptimizationPeriod.finishedAt,
              Datetime.getISONow(0, false)
            ),
            start: Datetime.toLocalTime(latestOptimizationPeriod.periodStart, 'onlyDate'),
            end: Datetime.toLocalTime(latestOptimizationPeriod.periodEnd, 'onlyDate'),
          })
        : t('No completed optimization yet')}
    </div>
  )
}
